import { Radio } from "antd";
import React from "react";
import { HelpBubble } from "~/components/help/helpBubble.jsx";
import { $t } from "~/i18n.js";

const getOgnDescriptions = () => [
  `**${$t("Manueel")}**: ${$t("Start/landings tijden worden manueel door de tijdschrijver toegekend.")}`,
  `**${$t("Automatisch")}**: ${$t("Start/landingstijden van vluchten worden automatisch aangevuld. Indien een kist nog niet is ingedeeld krijg je te zien dat hij vertrokken is, en de melding een vlieger te selecteren.")}`,
  `**${$t("Automatisch landen")}**: ${$t("Alleen de landings tijden worden automatisch aangevuld, deze modus kan handig zijn als de OGN receiver niet goed is gericht op de landingsbaan")}.`,
];

export const OgnModeHelpBubble = () => (
  <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
    {$t("Tijdschrijven methode")}
    <HelpBubble
      title={$t("Methode van tijdschrijven")}
      content={getOgnDescriptions().join("\n\n")}
    />
  </span>
);

export const OgnModeDescriptions = () => (
  <>
    <p>
      <span className="bold">{$t("Manueel")}</span>:{" "}
      {$t("Start/landings tijden worden manueel door de tijdschrijver toegekend.")}
    </p>
    <p>
      <span className="bold">{$t("Automatisch")}</span>:{" "}
      {$t("Start/landingstijden van vluchten worden automatisch aangevuld. Indien een kist nog niet is ingedeeld krijg je te zien dat hij vertrokken is, en de melding een vlieger te selecteren.")}
    </p>
    <p>
      <span className="bold">{$t("Automatisch landen")}</span>:{" "}
      {$t("Alleen de landings tijden worden automatisch aangevuld, deze modus kan handig zijn als de OGN receiver niet goed is gericht op de landingsbaan")}
      .{" "}
      {$t("OGN werkt het beste als er een club receiver geinstalleerd is die rechtstreeks zicht heeft op het veld")}
    </p>
  </>
);

export const OgnModeRadioGroup = (props) => (
  <Radio.Group buttonStyle="solid" {...props}>
    <Radio.Button value="manueel">{$t("Manueel")}</Radio.Button>
    <Radio.Button value="auto">{$t("Automatisch")}</Radio.Button>
    <Radio.Button value="auto_land">{$t("Automatisch landen")}</Radio.Button>
  </Radio.Group>
);
